document.addEventListener('DOMContentLoaded', () => {
  const forms = Array.from(document.querySelectorAll('form[data-evergreen-forms-proxy="1"]'));
  if (!forms.length) return;

  const ajaxurl = window.fritzScripts?.ajaxurl;
  const nonce = window.fritzScripts?.security;
  const recaptchaKey = typeof window.fritzScripts?.recaptchaKey === 'string'
    ? window.fritzScripts.recaptchaKey.trim()
    : '';
  const recaptchaEnabled = Boolean(window.fritzScripts?.recaptchaEnabled) && recaptchaKey !== '';

  if (!ajaxurl || !nonce) return;

  const ensureFormId = (form) => {
    if (form.id) return form.id;
    form.id = `evergreen-form-${Math.random().toString(16).slice(2)}`;
    return form.id;
  };

  const getFormWrapper = (form) => {
    return form.closest('.signup-form__form') || form.parentElement || form;
  };

  const setBusy = (form, isBusy) => {
    form.dataset.evergreenFormsBusy = isBusy ? '1' : '';

    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = isBusy;
  };

  const showErrorMessage = (form, message) => {
    const wrapper = getFormWrapper(form);
    let container = wrapper.querySelector('.evergreen-forms-proxy__message--error');
    if (!container) {
      container = document.createElement('div');
      container.className = 'evergreen-forms-proxy__message evergreen-forms-proxy__message--error';
      container.setAttribute('role', 'status');
      container.setAttribute('aria-live', 'polite');
      container.hidden = true;
      wrapper.append(container);
    }

    container.textContent = message || '';
    container.hidden = !container.textContent;
  };

  const showSuccessAndReplaceForm = (form, message) => {
    const container = document.createElement('div');
    container.className = 'evergreen-forms-proxy__message evergreen-forms-proxy__message--success';
    container.setAttribute('role', 'status');
    container.setAttribute('aria-live', 'polite');
    container.textContent = message || '';

    form.replaceWith(container);
  };

  const submitViaAjax = async (form) => {
    const formId = ensureFormId(form);
    const formData = new FormData(form);
    const fields = [];

    for (const [name, value] of formData.entries()) {
      fields.push({ name, value });
    }

    const ajaxEndpoint = new URL(ajaxurl, window.location.href);
    ajaxEndpoint.searchParams.set('action', 'evergreen_forms_submit');

    const payload = {
      security: nonce,
      endpoint: form.dataset.evergreenFormsEndpoint || '',
      fields,
      formId,
    };

    if (recaptchaEnabled) {
      if (!window.grecaptcha || typeof window.grecaptcha.ready !== 'function' || typeof window.grecaptcha.execute !== 'function') {
        throw new Error('recaptcha_unavailable');
      }

      const recaptchaToken = await new Promise((resolve, reject) => {
        window.grecaptcha.ready(() => {
          window.grecaptcha.execute(recaptchaKey, { action: 'evergreen_forms_submit' }).then(resolve).catch(reject);
        });
      });

      if (!recaptchaToken) {
        throw new Error('recaptcha_missing_token');
      }

      payload.recaptchaToken = recaptchaToken;
      payload.recaptchaAction = 'evergreen_forms_submit';
    }

    const response = await fetch(ajaxEndpoint.toString(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    const json = await response.json();
    const ok = Boolean(json?.success && json?.data?.ok);

    return { ok, json };
  };

  forms.forEach((form) => {
    ensureFormId(form);

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (form.dataset.evergreenFormsBusy === '1') return;

      setBusy(form, true);

      try {
        const { ok, json } = await submitViaAjax(form);

        if (ok) {
          showSuccessAndReplaceForm(form, form.dataset.evergreenFormsSuccess || 'Thanks for signing up!');

          window.dispatchEvent(new CustomEvent('evergreen:signup:success', {
            detail: {
              formId: form.id,
              form,
              response: json,
            },
          }));

          return;
        }

        if (json?.data?.code) {
          console.warn('Evergreen forms proxy failed:', json.data.code, json.data);
        }
        showErrorMessage(form, form.dataset.evergreenFormsFailure || 'Sorry — something went wrong. Please try again.');
      } catch (e) {
        console.warn('Evergreen forms proxy failed:', e);
        showErrorMessage(form, form.dataset.evergreenFormsFailure || 'Sorry — something went wrong. Please try again.');
      } finally {
        setBusy(form, false);
      }
    });
  });
});
